import {UserSettings, UserSettingsRaw} from '../../interfaces/settings';

export const sanitizeUserSettingsFromRaw = (
  data: UserSettingsRaw
): UserSettings => {
  return {
    senseAutoJoin: data.sense_auto_join,
    autoDeleteVideoAfterAnalysis: data.auto_delete_video_after_analysis,
    meetingAnalysisLanguage: data.meeting_analysis_language ?? null,
  };
};

export const sanitizeUserSettingsForRaw = (
  data: Partial<UserSettings>
): Partial<UserSettingsRaw> => {
  return {
    ...(data.senseAutoJoin !== undefined && {
      sense_auto_join: data.senseAutoJoin,
    }),
    ...(data.autoDeleteVideoAfterAnalysis !== undefined && {
      auto_delete_video_after_analysis: data.autoDeleteVideoAfterAnalysis,
    }),
    ...(data.meetingAnalysisLanguage !== undefined && {
      meeting_analysis_language: data.meetingAnalysisLanguage,
    }),
  };
};
